import classnames from 'classnames/bind'
import React from 'react'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import AbstractTable, {
  TableProps as AbstractTableProps,
} from '~/components/Abstracts/Table'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type TableProps = AbstractTableProps & {
  className?: string
}

function Table({ className, ...rest }: TableProps) {
  const tableStyle = useStyle({
    textPreset: GlobalTextPreset.Text12GroteskRegular,
    textStyling: GlobalTextStyling.UpperCase,
  })

  const labelsStyle = useStyle({
    textPreset: GlobalTextPreset.Text12GroteskMedium,
    textStyling: GlobalTextStyling.UpperCase,
  })

  return (
    <AbstractTable
      className={cx(css.Table, className, tableStyle)}
      theadClassName={cx(css.thead, labelsStyle)}
      tbodyClassName={css.tbody}
      desktopTbodyClassName={css.tbodyDesktop}
      firstColumnDesktopClassName={cx(css.firstColumnDesktop, labelsStyle)}
      {...rest}
    />
  )
}

Table.defaultProps = {}

export default Table
